var l = Object.defineProperty;
var m = (n, e, t) => e in n ? l(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var c = (n, e, t) => m(n, typeof e != "symbol" ? e + "" : e, t);
import { TENANT_OBJECT_COLLECTION as r } from "../objects/constants.mjs";
class h {
  constructor(e) {
    c(this, "instance");
    this.instance = e;
  }
  async authCheck({ tenant: e, knockChannelId: t }) {
    const s = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/providers/ms-teams/${t}/auth_check`,
      params: {
        ms_teams_tenant_object: {
          object_id: e,
          collection: r
        },
        channel_id: t
      }
    });
    return this.handleResponse(s);
  }
  async getTeams(e) {
    const { knockChannelId: t, tenant: s } = e, a = e.queryOptions || {}, o = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/providers/ms-teams/${t}/teams`,
      params: {
        ms_teams_tenant_object: {
          object_id: s,
          collection: r
        },
        query_options: {
          $filter: a.$filter,
          $select: a.$select,
          $top: a.$top,
          $skiptoken: a.$skiptoken
        }
      }
    });
    return this.handleResponse(o);
  }
  async getChannels(e) {
    const { knockChannelId: t, teamId: s, tenant: a } = e, o = e.queryOptions || {}, i = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/providers/ms-teams/${t}/channels`,
      params: {
        ms_teams_tenant_object: {
          object_id: a,
          collection: r
        },
        team_id: s,
        query_options: {
          $filter: o.$filter,
          $select: o.$select
        }
      }
    });
    return this.handleResponse(i);
  }
  async revokeAccessToken({
    tenant: e,
    knockChannelId: t
  }) {
    const s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/providers/ms-teams/${t}/revoke_access`,
      params: {
        ms_teams_tenant_object: {
          object_id: e,
          collection: r
        },
        channel_id: t
      }
    });
    return this.handleResponse(s);
  }
  handleResponse(e) {
    var t, s;
    if (e.statusCode === "error") {
      if (((s = (t = e.error) == null ? void 0 : t.response) == null ? void 0 : s.status) < 500)
        return e.error || e.body;
      throw new Error(e.error || e.body);
    }
    return e.body;
  }
}
export {
  h as default
};
//# sourceMappingURL=index.mjs.map
